import { render } from "./HighQuality.vue?vue&type=template&id=1684aa99&scoped=true"
import script from "./HighQuality.vue?vue&type=script&lang=js"
export * from "./HighQuality.vue?vue&type=script&lang=js"

import "./HighQuality.vue?vue&type=style&index=0&id=1684aa99&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1684aa99"]])

export default __exports__